<template>
  <b-card no-body>
    <b-card-body>
      <!-- Filtros -->
      <b-card bg-variant="light">
        <b-form-row @keyup.enter="load">
          <b-col lg="12" sm="12" class="text-left">
            <!-- Unidade Administrativa -->
            <b-col lg="6" sm="6" class="text-left">
              <LgFinderPageUnidadeAdministrativa id="finderUnidadeAdministrativa" label="Unidade Administrativa:"
                @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                invalidFeedback="Informe uma unidade administrativa!" />
            </b-col>

            <lg-form-input sm="3" v-model="form.ano" label="Ano:"  description=" " />


            <!-- Gestor (desabilitado) -->
            <lg-form-input sm="3" v-model="form.gestor" label="Gestor:" disabled description=" " />

          </b-col>

          <!-- Botões de Ação -->
          <b-col lg="12" sm="12" class="text-right mt-3">
            <b-button id="localizarInventario" class="mx-1 my-3" size="sm" style="height: 20px" pill variant="primary"
              @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" /> &nbsp;
              </div>

              <b-tooltip target="localizarInventario" title="Localizar"></b-tooltip>
            </b-button>

            <b-button id="limparInventario" class="mx-1 my-3" size="sm" style="height: 20px" pill variant="primary"
              @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="eraser" /> &nbsp;
              </div>

              <b-tooltip target="limparInventario" title="Limpar"></b-tooltip>
            </b-button>
          </b-col>
        </b-form-row>
      </b-card>

      <!-- Tabela -->
      <b-card bg-variant="light" class="mt-3">
        <b-table :items="inventarios" :fields="tableFields" :busy="busy" responsive small hover show-empty>
          <template #empty>
            <p class="text-center">Nenhum registro encontrado</p>
          </template>
          <template #cell(acoes)="row">
            <b-button-group>
              <b-button size="sm" variant="primary" @click="editar(row.item)">
                <b-icon icon="pencil-square" /> Editar
              </b-button>
            </b-button-group>
          </template>
        </b-table>

        <!-- Paginação -->
        <b-row class="mt-2">
          <b-col cols="6" class="d-flex align-items-center">
            <span>Página {{ page }} de {{ totalPage }} - {{ total }} registros</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-pagination v-model="page" :per-page="perPage" :total-rows="total" @change="load" />
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
  </b-card>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import InventarioAnualService from "@/core/api/InventarioAnualService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue"

export default {
  components: {
    LgFinderPageUnidadeAdministrativa,
    LgFormInput
  },
  data() {
    return {
      busy: false,
      page: 1,
      perPage: 10,
      totalPage: 1,
      total: 0,
      inventarios: [],
      form: {
        ano: "",
        departamento: null,
        gestor: "",
      },
      tableFields: [
        { key: "ano", label: "Ano" },
        { key: "dataInicio", label: "Data da Carga" },
        { key: "departamento.descricao", label: "Unidade Administrativa" },
        { label: "Gestor da Unidade" },
        { key: "observacao", label: "Observação" },
        { key: "totalIBPs", label: "Total de IBPs" },
        { key: "sobras", label: "Sobras" },
        { key: "faltas", label: "Faltas" },
      ],
    };
  },
  methods: {
    handleSelectUnidadeAdministrativa(departamento) {
      this.form.departamento = departamento;
      this.form.gestor = departamento ? departamento.descricao : "";
      this.load();
    },
    clearForm() {
      this.form = {
        ano: "",
        departamento: null,
        gestor: "",
      };
      this.load();
    },
    async load() {
      this.busy = true;
      try {
        const params = {
          ano: this.form.ano ? this.form.ano : null,
          departamentoId: this.form.departamento ? this.form.departamento.id : undefined,
          page: this.page - 1,
          size: this.perPage,
        };

        const response = await InventarioAnualService.buscarInventarioPorAnoEDepartamento(params.ano, params.departamentoId, { page: params.page, size: params.size });
        this.inventarios = response.data.content;
        this.total = response.data.totalElements;
        this.totalPage = response.data.totalPages;
      } catch (error) {
        console.error("Erro ao carregar inventários:", error);
      } finally {
        this.busy = false;
      }
    },
    editar(item) {
      // Função para editar inventário
      console.log("Editar item", item);
    }
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped>
.btn-input-finder {
  padding: 0 8px;
  height: 28px;
}
</style>
